(() => {
  const observed = new WeakSet();
  const pending = new WeakSet();
  const combinations = new WeakMap();
  const visible = element => element.getClientRects().length > 0 && getComputedStyle(element).display !== 'none' && getComputedStyle(element).visibility !== 'hidden';
  function sync(root) {
    const input = root.querySelector('form.product-form[data-product-form] [data-variant-id-input]');
    const key = input?.value ? `|${input.value}|` : '';
    const rows = Array.from(root.querySelectorAll('kaching-bundle .kaching-bundles__bar-variant-selects'))
      .map(row => Array.from(row.querySelectorAll('select')).filter(select => !select.disabled && visible(select)).map(select => select.value.trim()))
      .filter(row => row.length > 0);
    const loading = root.hasAttribute('data-variant-loading');
    root.querySelectorAll('[data-zorura-scoped-facts]').forEach(panel => {
      const groups = Array.from(panel.querySelectorAll('[data-zorura-fact-group]'));
      const bundleGroups = rows.length ? groups.filter(group => {
        if (!combinations.has(group)) combinations.set(group, JSON.parse(group.dataset.optionCombinations));
        return rows.some(row => combinations.get(group).some(options => options.length === row.length && options.every((value, index) => value === row[index])));
      }) : [];
      const selected = bundleGroups.length ? bundleGroups : groups.filter(group => key && group.dataset.variantIds.includes(key));
      groups.forEach(group => {
        const show = !loading && selected.includes(group);
        if (group.hidden === show) group.hidden = !show;
        const label = group.querySelector('[data-zorura-fact-choice]');
        const showLabel = show && selected.length > 1;
        if (label.hidden === showLabel) label.hidden = !showLabel;
      });
    });
  }
  function schedule(root) {
    if (pending.has(root)) return;
    pending.add(root);
    requestAnimationFrame(() => { pending.delete(root); sync(root); });
  }
  function scan() {
    document.querySelectorAll('[data-section-type="product"]').forEach(root => {
      if (!root.querySelector('[data-zorura-scoped-facts]') || observed.has(root)) return;
      observed.add(root);
      root.addEventListener('change', () => schedule(root));
      root.addEventListener('input', () => schedule(root));
      new MutationObserver(() => schedule(root)).observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-variant-loading', 'value', 'data-value', 'checked', 'class'] });
      sync(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', scan);
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
})();
